const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function tiktokBreakoutProductReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_TIKTOK_BREAKOUT_PRODUCT':
			return {
				...state,
				isLoading: action?.payload
			};
		case 'ADMIN_TIKTOK_BREAKOUT_PRODUCT':
			return {
				...state,
				list: action?.payload?.product_sales_rising_rank || [],
				totalsize: action?.payload?.totalsize || 0
			};
		default:
			return state;
	}
}

export default tiktokBreakoutProductReducer;
